import { AbstractControl, ValidatorFn } from '@angular/forms';
import { _ } from '@ngx-translate/core';
import { isValidPhoneNumber } from 'libphonenumber-js/core';
import metadata from 'libphonenumber-js/min/metadata';
import { checkPhoneNumber } from '@src/utils';

const customMask = '+888 000 000-00';

export const inputPhoneValidator = (value: string): boolean => {
  return isValidPhoneNumber(value, metadata) || checkPhoneNumber(value, customMask);
};

export const inputPhoneFormValidator = (allowedString?: string): ValidatorFn => {
  return ({ value }: AbstractControl) => {
    if (value) {
      if (value === allowedString) {
        return null;
      }

      return !inputPhoneValidator(value)
        ? {
            // FIXME: не работает в связке с tui-error
            phoneInvalid: _('common.alerts.errors.phone'),
          }
        : null;
    }

    return null;
  };
};
